export const momentFormat: object = {
    dateFormat_0:  "DD.MM.YYYY HH:mm:ss",
    dateFormat_1:  "DD.MM.YYYY HH:mm",
    dateFormat_2:  "DD.MM.YYYY",
    dateFormat_3:  "HH:mm:ss",
    dateFormat_4:  "HH:mm",
    dateFormat_5:  "YYYY",
    dateFormat_6:  "MMMM YYYY",
    dateFormat_7:  "dddd, D.MMMM YYYY",
    dateFormat_8:  "[CW] W YYYY",
    dateFormat_9:  "MM.YYYY",
    dateFormat_10: "dddd",
    dateFormat_11: "MMM YY",
    dateFormat_12: "MMM YYYY",
    dateFormat_13: "[CW] W",
    dateFormat_14: "W",
};
